import { createAction } from '@ngrx/store';

export const getUnitGroups = createAction(
  '[UnitGroups] Get Unit Group',
);

export type UnitGroupsActionsUnion = ReturnType<typeof getUnitGroups>;
